import { BuyNow } from '../../../../Common/buttons/buy-now';
import { KnowMore } from '../../../../Common/buttons/know-more';
import { Heading, HeadingType, Paragraph } from '../../../../Typography';
import { KeyFeatures } from '../../../../partner-pages/price_cards/key-features';
import { OfferPricingCard } from '../../../../partner-pages/price_cards/offer-pricing-card';
import { useDataForPlans } from '../../../../partner-pages/utils/use-plan-data';
import {
  getCheckoutUrl,
  getPlanPageUrl,
} from '../../../../partner-pages/utils/utils';
import { TShowcasedPlan } from '../../types';
import { Branding } from './branding';

interface IShowCasedFold {
  showcaseFold: TShowcasedPlan;
}

export const ShowCasedFold: React.FC<IShowCasedFold> = ({ showcaseFold }) => {
  const planData = useDataForPlans(
    showcaseFold?.plan_id ? [showcaseFold.plan_id] : [],
    'partner'
  );
  const plan = planData[0]?.planDetails;
  if (!plan || !showcaseFold) return <></>;
  return (
    <div className="py-14 sm:pb-0">
      <Heading
        content={showcaseFold.title}
        variant={HeadingType.h2}
        className="text-s-48 mb-2.5 sm:text-s-32"
      />
      <Paragraph className="w-1/2 sm:w-full sm:mb-3">
        {showcaseFold.description}
      </Paragraph>
      <div className="flex w-full justify-between">
        <div className="w-1/2 sm:w-full">
          <div className="inline-flex p-4 py-2 items-center border-sm border-green-250 rounded-sm bg-[#F9FFFC] mb-6 mt-6">
            <img
              src="https://assets1.cleartax-cdn.com/cleartax/images/1682414688_group18142367.svg"
              alt="coin"
              width={24}
              height={24}
              className="mr-4"
            />
            <div>
              <OfferPricingCard
                pricing={plan.pricing}
                originalPrice={plan.offerPricing.originalPrice}
                coupon={null}
                productServiceType={plan.productServiceType}
                idPrefix="showcased-expert"
              />
            </div>
          </div>
          <KeyFeatures
            services={plan.servicesIncluded}
            textClasses="text-s-20 font-medium"
          />
          <div className="flex items-center pt-12 sm:pt-4 sm:flex-col">
            <BuyNow
              href={getCheckoutUrl(plan.listingId)}
              funnelMetricLabel="showcase-fold"
              className="sm:w-full"
              id="showcased-expert-buy-now"
            />
            <KnowMore
              href={getPlanPageUrl(plan.planId)}
              funnelMetricLabel="plan-card"
              className="sm:w-full sm:text-center sm:py-3 mt-2"
              id="showcased-expert-know-more"
            />
          </div>
        </div>
        {/* <div className="w-1/3 sm:hidden">
          <Lottie animationData={pricingHeroFold} loop={true} />
        </div> */}
      </div>
      <Branding />
    </div>
  );
};
